/*eslint-disable*/
import React from 'react'
import PropTypes from 'prop-types'
import ReactSelect from 'react-select'

const Select = (props) => {
  const {label,simpleValue=true,multi=false,focused=false,...rest} = props;
  return (
    <div className="form-horizontal">
      <div className="form-group">
        <label className="col-lg-4 col-md-4 col-sm-6 col-xs-6">{label}</label>
        <div className="col-lg-8 col-md-8 col-sm-6 col-xs-6">
          <ReactSelect.AsyncCreatable
            {...rest}
            simpleValue={simpleValue}
            clearable={true}
            multi={multi}
            placeholder="All"
            promptTextCreator={promptTextCreator}
            autofocus={focused}
          />
        </div>
      </div>
    </div>
  );
};

Select.PropTypes = {
  label: PropTypes.string.isRequired,
  loadOptions: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.string,
  focused: PropTypes.bool,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string
};

export default Select

const promptTextCreator = (label)=>{
  return `Contains "${label.toLowerCase()}"`;
};


// WEBPACK FOOTER //
// ./src/components/SearchInput.jsx